export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('../../views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('../../views/pages/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('../../views/pages/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('../../views/pages/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset/password',
    name: 'auth-reset-password',
    component: () => import('../../views/pages/ResetPassword.vue'),
  },
  {
    path: '/new/password',
    name: 'auth-new-password',
    component: () => import('../../views/pages/NewPassword.vue'),
  },
  {
    path: '/verify/email',
    name: 'auth-verify-email',
    component: () => import('../../views/pages/EmailVerify.vue'),
  },
  {
    path: '/user',
    alias: '/admin',
    name: 'auth-dashboard',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/register/success',
    name: 'auth-register-success',
    component: () => import('../../views/pages/RegisterSuccess.vue'),
  },
  {
    path: '/user/transactions',
    name: 'user-transactions',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/transactions/details',
    name: 'user-transactions-details',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/withdraw',
    name: 'user-withdraw',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/withdraw/token',
    name: 'user-withdraw-token',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/withdraw/token/referral',
    name: 'user-withdraw-token-referral',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/contribute',
    name: 'user-contribute',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/profile',
    name: 'user-profile',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/activity',
    name: 'user-activity',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/edit',
    name: 'user-edit',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/referral',
    name: 'user-referral',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc',
    name: 'user-kyc',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc/application',
    name: 'user-kyc-application',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc/success',
    name: 'user-kyc-success',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc/pending',
    name: 'user-kyc-pending',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc/rejected',
    name: 'user-kyc-rejected',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/kyc/missing',
    name: 'user-kyc-missing',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/account/balance',
    name: 'user-account-balance',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/wallet/connect',
    name: 'user-wallet-connect',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/login/2fa',
    name: 'auth-login-2fa',
    component: () => import('../../views/pages/Login2FA.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  //admin routes
  {
    path: '/admin/transactions',
    name: 'admin-transactions',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/transactions/details',
    name: 'admin-transactions-details',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/transactions/add',
    name: 'admin-add-token',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/withdraw',
    name: 'admin-withdraw',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/withdraw/details',
    name: 'admin-withdraw-details',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/withdraw/settings',
    name: 'admin-withdraw-settings',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/kyc-list',
    name: 'admin-kyc-list',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/kyc/settings',
    name: 'admin-kyc-settings',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/kyc/details',
    name: 'admin-kyc-details',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/kyc/approve',
    name: 'admin-kyc-approve',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/users',
    name: 'admin-users',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/users/walletchange',
    name: 'admin-users-walletchange',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/details',
    name: 'admin-user-details',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/add',
    name: 'admin-add-user',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/transactions',
    name: 'admin-user-transactions',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/activities',
    name: 'admin-user-activities',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/referrals',
    name: 'admin-user-referrals',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/user/sendemail',
    name: 'admin-user-sendemail',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/stages',
    name: 'admin-stages',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/stages/overview',
    name: 'admin-stages-overview',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/stages/update/:id?',
    name: 'admin-stages-update',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/stages/add',
    name: 'admin-stages-add',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings',
    name: 'admin-settings',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/stages',
    name: 'admin-settings-stages',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/lockPeriod',
    name: 'admin-settings-lockPeriod',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/referral',
    name: 'admin-settings-referral',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/email',
    name: 'admin-settings-email',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/chooseemail',
    name: 'admin-settings-chooseemail',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/settings/email/detail',
    name: 'admin-settings-email-detail',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/payment-methods',
    name: 'admin-payment-methods',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/payment-methods/edit',
    name: 'admin-payment-methods-edit',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/manage-currency',
    name: 'admin-manage-currency',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/pages',
    name: 'admin-pages',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/pages/detail',
    name: 'admin-pages-detail',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/profile',
    name: 'admin-profile',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/activity',
    name: 'admin-activity',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/manage-role',
    name: 'admin-manage-role',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/admin/manage-role/settings',
    name: 'admin-manage-role-settings',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/payment/process',
    name: 'user-payment-process',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/payment/review',
    name: 'user-payment-review',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/payment/confirmation',
    name: 'user-payment-confirmation',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
  {
    path: '/user/withdraw/details',
    name: 'user-details-withdraw',
    component: () => import('../../views/dashboard/Dashboard.vue'),
  },
]


// WEBPACK FOOTER //
// ./src/router/routes/pages.js